import script from "./Crosshair.vue?vue&type=script&lang=js"
export * from "./Crosshair.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__